import PropTypes from 'prop-types'
import React from 'react';
import Image from './images'

const Home = ({ timeout, menuBar }) => {

	return (
		<div id="home" style={timeout ? { display: 'none' } : menuBar ? {} : {}}>

			<Image imageName="profile-pic.png" className="profile-pic" alt="profile-pic" />

			<div className="content" style={menuBar ? {} : { zIndex: '5' }}>
				<div className="inner">
					<h1>Leonil <span className="secondary">Omayan</span></h1>
					<p></p>
					<ul className="icons">
						<li>
							<a
								target="_blank" rel="noreferrer"
								href="https://twitter.com/LeonilOmayan93?s=09"
								className="icon fab fa-twitter"
							>
								<span className="label">Twitter</span>
							</a>
						</li>
						<li>
							<a
								target="_blank" rel="noreferrer"
								href="https://facebook.com/leonil.omayan"
								className="icon fab fa-facebook-f">
								<span className="label">Facebook</span>
							</a>
						</li>
						<li>
							<a
								target="_blank" rel="noreferrer"
								href="https://instagram.com/leo_nil_"
								className="icon fab fa-instagram">
								<span className="label">Instagram</span>
							</a>
						</li>
						<li>
							<a
								target="_blank" rel="noreferrer"
								href="https://github.com/Leonil1993"
								className="icon fab fa-github"
							>
								<span className="label">GitHub</span>
							</a>
						</li>
						<li>
							<a
								href="tel:+639059538246"
								className="icon fas fa-phone"
							>
								<span className="label">Phone Number</span>
							</a>
						</li>
						{/*<li className={`menu-brand-item ${props.menuBar ? 'show' : '' }`}>
					    <a
					      target="_blank" rel="noreferrer"
					      href="https://www.google.com.ph/maps/@7.1032078,125.4992702,18z"
					      className="icon fab fa-map"
					    >
					      <span className="label">Map</span>
					    </a>
					  </li>*/}
						<li className={`menu-brand-item ${menuBar ? 'show' : ''}`}>
							<a
								href="mailto:leonil.omayan.lo@gmail.com"
								className="icon far fa-envelope"
							>
								<span className="label">Map</span>
							</a>
						</li>
					</ul>
				</div>
			</div>
		</div>
	);
}

Home.propTypes = {
	timeout: PropTypes.bool,
	menuBar: PropTypes.bool
}

export default Home